import Vue from 'vue'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueMobileDetection from 'vue-mobile-detection'
import VueRouter from 'vue-router'
import router from './router'
import VueUseWebp from 'vue-use-webp'

library.add(faAngleDown)
library.add(faAngleRight)

AOS.init()

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueMobileDetection)
Vue.use(VueRouter)
Vue.use(VueUseWebp)

Vue.config.productionTip = true

// eslint-disable-next-line
new Vue({
  el: '#app',
  template: '<App/>',
  router,
  components: { App }
})
